/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillCashtagsRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_cashtags.pb'
import {BackfillCashtagsResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_cashtags.pb'


export const backfillCashtags = (request: BackfillCashtagsRequest, options?: CashRequestOptions) => post<BackfillCashtagsRequest, BackfillCashtagsResponse>("/2.0/cash/backfill-cashtags", request, {...options, rejectOnError: true })